<template>
  <div id="ReportManage" class="well" style="padding: 0 1em">
    <b-button variant="success" v-on:click="dataMode = 1">學年度統計</b-button>

    <b-tabs content-class="mt-3" justified>
      <b-tab :active="dataMode == 1" :disabled="dataMode != 1">
        <table cellpadding="0" cellspacing="0" class="ncut-table-search">
          <tbody>
            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 3em">申請最低入學年度：</th>
                <th style="min-width: 3em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.STime"
                    placeholder="如108"
                  />
                </th>
                <th style="min-width: 3em">申請查詢學年度：</th>
                <th style="min-width: 1em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="3"
                    v-model="queryInfo.Text1"
                    placeholder="如111"
                  />
                </th>
                <th style="min-width: 3em">申請查詢學期：</th>
                <th style="min-width: 1em">
                  <input
                    type="text"
                    onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                    onafterpaste="this.value=this.value.replace(/[^0-9]/g,\'\')"
                    onpaste="return false"
                    maxlength="1"
                    v-model="queryInfo.ETime"
                    placeholder="如1"
                  />
                </th>
                <th>查詢日期：</th>
                <th style="min-width: 12em">
                  <b-input-group class="mb-3">
                    <b-form-input
                     id="ApplyTime"
                      v-model="ApplyTime"
                      ref="ApplyTime"
                      type="text"
                      placeholder="YYYY-MM-DD"
                      autocomplete="off"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-form-datepicker
                        v-model="ApplyTime"
                        button-only
                        right
                        locale="zh-tw"
                        aria-controls="example-input"
                        @context="onContext"
                      ></b-form-datepicker>
                    </b-input-group-append>
                  </b-input-group>
                </th>

                <th style="min-width: 9em" colspan="3">
                  <b-button variant="success" tabindex="3" @click="query()"
                    ><b-icon icon="search" />&nbsp;{{
                      $t("message.Query_cmd")
                    }}</b-button
                  >&nbsp;

                  <a
                    style="margin: 0 0.5rem; text-decoration: none"
                    target="_blank"
                    tabindex="4"
                    class="ncut-excel-style"
                    :href="
                      './WebApi/EconomicDisadvantage/GetSportsODS/'
                        .concat(queryInfo.STime)
                        .concat(',')
                        .concat(queryInfo.ETime)
                        .concat(',')
                        .concat(queryInfo.dataMode)
                        .concat(',')
                        .concat(queryInfo.Date1Str)
                        .concat(',')
                        .concat(queryInfo.Text1)
                    "
                    v-show="total > 0"
                  >
                    <img
                      src="@/assets/images/ods-file24.png"
                      style="height: 0.8rem"
                    />
                    {{ $t("message.Excel_txt") }}
                  </a>
                </th>
              </tr>
            </thead>
          </tbody>
        </table>

        <div
          class="dataTables_scrollBody"
          style="
            position: relative;
            overflow: auto;

            max-height: 400px;
            width: 100%;
            border-bottom: 1px solid #111;
            border-top: 1px solid #111;
          "
        >

          <table
            class="ncut-table-menu-striped ncut-table-menu"
            bgcolor="#FFFFFF"
          >

            <thead class="ncut-thead-menu">
              <tr>
                <th style="min-width: 2.5em">學年</th>
                <th style="min-width: 2.5em">學期</th>
                <th style="min-width: 2.5em">入學年</th>
                <th style="min-width: 7em">科系</th>
                <th style="min-width: 7em">班級名稱</th>
                <th style="min-width: 2.5em">年級</th>
                <th style="min-width: 2.5em">班級總人數</th>
                <th style="min-width: 2.5em">申請人數</th>
                <th style="min-width: 2.5em">通過人數</th>
                <th style="min-width: 2.5em">申請比例</th>
                <th style="min-width: 2.5em">通過比例</th>
              </tr>
            </thead>
            <tbody class="ncut-tbody-menu">
              <tr
                v-for="(item, index) in filteredDocs"
                :key="item.id"
                :index="item.id"
                v-bind:style="{
                  background: selectedRowIndex == index ? headerColor : '',
                }"
                @click="selectedRowIndex = index"
              >
                <td style="text-align: right">
                  {{ item.schyy }}
                </td>
                <td style="text-align: left">{{ item.smt }}</td>
                <td style="text-align: left">{{ item.startYear }}</td>
                <td style="text-align: left">{{ item.dptnm }}</td>
                <td style="text-align: left">{{ item.clsnm }}</td>
                <td style="text-align: left">{{ item.gd }}</td>
                <td style="text-align: left">{{ item.clsnmNumber }}</td>
                <td style="text-align: left">{{ item.applyNumber }}</td>
                <td style="text-align: left">{{ item.passNumber }}</td>
                <td style="text-align: left">{{ item.applyPa }}%</td>
                <td style="text-align: left">{{ item.passPa }}%</td>
              </tr>
            </tbody>
          </table>
          <b-pagination
            v-model="currentPage"
            :total-rows="total"
            :per-page="pageSize"
            :limit="21"
            v-if="total > pageSize"
          />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script  id="modal-template">
import * as tools from "../tool";
export default {
  name: "ReportManage",
  data() {
    return {
      ApplyTime:null,
      total: 0,
      dataMode: 1,
      currentPage: 1,
      selectedRowIndex: 0,
      editId: 0,
      pageSize: 100,
      queryInfo: {
        STime: null,
        ETime: null,
        dataMode: 0,
        Date1Str:null,
        Text1:null,
      },
      docRecordList: [],
    };
  },

  computed: {
    sysId() {
      return this.$store.getters.getSysId;
    },
    setting() {
      return this.$store.getters.getSetting;
    },

    filteredDocs: function () {
      let data = [];
      if (this.docRecordList != null) {
        data = this.docRecordList.slice(
          (this.currentPage - 1) * this.pageSize,
          this.currentPage * this.pageSize
        );
      }
      return data;
    },
    headerColor() {
      return "#f7e8aa";
    },
  },
  filters: {},
  methods: {
    onContext(ctx) {
      this.ApplyTime = ctx.selectedYMD; //Selected: '2022-02-22'
    },

    checkSaveData() {
      let msg = "";
      if (this.queryInfo.STime == null) msg = "請輸入最低入學年度";
      else if (this.queryInfo.Text1 == null) msg = "請輸入查詢學年度";
      else if (this.queryInfo.ETime == null) msg = "請輸入查詢學期";
      else if (this.ApplyTime == null) msg = "請輸入查詢日期";
      return msg;
    },
    query() {
      var msg = this.checkSaveData();
      if (0 == msg.length) {
        let vm = this;
        vm.docRecordList = null;
        vm.total = 0;
        vm.queryInfo.dataMode = vm.dataMode;
        vm.queryInfo.Date1Str=vm.ApplyTime;

        this.$http
          .put("./WebApi/EconomicDisadvantage/GetSportsList", vm.queryInfo)
          .then((response) => {
            if (response.data != null) {
              vm.docRecordList = response.data;
              vm.total = vm.docRecordList.length;
            }
          })
          .catch(function (error) {
            tools.showAlert(vm, "danger", "對不起,網路連線失敗" + error);
          });
      } else {
        tools.showAlert(this, "danger", "對不起,請輸入" + msg);
      }
    },
  },
  created() {
    console.log("======created ReportManageView =====");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn1 {
  color: #e2e1e4;
  background-color: #c1651a;
  border-color: #a7a8bd;
}
.btn2 {
  color: #e2e1e4;
  background-color: #1a3b32;
  border-color: #a7a8bd;
}
.span_text {
  display: block;
  width: 20rem;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
</style>
